/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:f5a3adc1-3a2b-429e-bdd6-885880ed7002",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_4sCCoaZll",
    "aws_user_pools_web_client_id": "14nq0m4auinaia6kk7h4ut5p94",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://uy5a915z9h.execute-api.ap-south-1.amazonaws.com/master",
            "region": "ap-south-1"
        }
    ]
};


export default awsmobile;
